<template>
  <div class="heat-map-container">
    <map-legend :state="state"></map-legend>
    <map-graphic :timeBlock="timeBlock" :state="state"></map-graphic>
  </div>
</template>

<script>
import HeatMapLegend from '../heat-map-legend/HeatMapLegend';
import HeatMapGraphic from '../heat-map-graphic/HeatMapGraphic';

export default {
  name: 'heat-map-container',
  props: ['timeBlock', 'state'],
  components: {
    'map-legend': HeatMapLegend,
    'map-graphic': HeatMapGraphic,
  },
};
</script>

<style lang="less">
  .heat-map-container {
    display: flex;
    width: 100%;
    height: 600px;
    overflow: scroll;
    overflow-x: hidden;
    @media print {
      overflow: visible;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// HeatMapContainer.vue?15d8fb77